import {
  FETCH_PRODUCT_TYPE_MEMBERS_FULFILLED,
  UPDATE_PRODUCT_TYPE_MEMBER_ROLE_FULFILLED,
} from './actions';

import type { ProductMemberInfo } from '@/types/productTypes';

export interface ProductTypeMembersAction {
  type: string;
  payload?: ProductMemberInfo[] | { memberId: string; data: ProductMemberInfo };
}

const productTypeMembersReducer = (
  state: ProductMemberInfo[] = [],
  action: ProductTypeMembersAction
): ProductMemberInfo[] => {
  switch (action.type) {
    case FETCH_PRODUCT_TYPE_MEMBERS_FULFILLED:
      return action.payload as ProductMemberInfo[];
    case UPDATE_PRODUCT_TYPE_MEMBER_ROLE_FULFILLED: {
      const { memberId, data } = action.payload as { memberId: string; data: ProductMemberInfo };
      if (!state.find(member => member.id === memberId)) {
        return [...state, data];
      }
      return state.map(member => {
        if (member.id === memberId) {
          return data;
        }
        return member;
      });
    }
    default:
      return state;
  }
};

export { productTypeMembersReducer };
